module.exports = __webpack_public_path__ + "static/media/avatar.8df0d107.svg";